import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  listDomains() {
    return session.get(`${APIEndpoint}/api/domains/`)
  },
  createDomain(domainData) {
    return session.post(`${APIEndpoint}/api/domains/`, domainData)
  },
  updateDomain(domainData) {
    // Ensure that domainData contains an 'id' key to identify the domain to update
    if (!domainData.id) {
      throw new Error("Domain update requires an 'id' field.");
    }
    return session.put(`${APIEndpoint}/api/domains/`, domainData)
  },
  deleteDomain(domainId) {
    return session.delete(`${APIEndpoint}/api/domains/?id=${domainId}`)
  },
}